<div class="footer">
    <div class="pt-4 pb-4">
      <div class="pt-2 fs-4 fw-bold">Talk to a Sierra Circuits PCB Expert today</div>
      <p>24 hours a day, 7 days a week.</p>
      <div class="fw-bold"><span>Call us: </span><span class="yellow-txt"> <a href="tel:+1 (800) 763-7503" class="yellow-txt text-decoration-none">+1 (800) 763-7503</a></span></div>
      <div class="fw-bold"><span>Email us:</span><span class="yellow-txt"> <a href="{{apiService.Customer_Care_URL}}" target="_blank" class="yellow-txt text-decoration-none"> through our Customer Care form</a></span></div>
    </div>
</div>